import { CapacityDto } from '../../../api/generated/api';

export declare interface ICapacity extends CapacityDto {
  add: (other: CapacityDto, normalize: boolean) => ICapacity;
  sub: (other: CapacityDto, normalize: boolean) => ICapacity;
  normalize: () => void;
  toMl: () => ICapacity;
  toLitr: () => ICapacity;
}

export class Capacity implements ICapacity {
  private _value: number;
  private _unit: CapacityDto.UnitEnum;

  constructor(value: number = 100, unit: CapacityDto.UnitEnum = CapacityDto.UnitEnum.MILLILITER, normalize: boolean = true) {
    this._value = value;
    this._unit = unit;
    if (normalize) {
      this.normalize();
    }
  }

  public get value() {
    return this._value;
  }

  public get unit() {
    return this._unit;
  }

  public add(other: ICapacity, normalize: boolean = true) {
    let c: ICapacity;
    if (this._unit === other.unit) {
      c = new Capacity(this._value + other.value!, this._unit!);
    } else {
      c = this.toMl().add(other.toMl(), false);
    }
    if (normalize) {
      c.normalize();
    }
    return c;
  }

  public sub(other: ICapacity, normalize: boolean = true) {
    let c: ICapacity;
    if (this._unit === other.unit) {
      const val = (this._value > other.value!) ? this._value - other.value! : 0;
      c = new Capacity(val, this._unit);
    } else {
      c = this.toMl().sub(other.toMl(), false);
    }
    if (normalize) {
      c.normalize();
    }
    return c;
  }

  public normalize() {
    if (this._unit === CapacityDto.UnitEnum.MILLILITER && this._value >= 1000) {
      this._value = this._value / 1000;
      this._unit = CapacityDto.UnitEnum.LITER;
    } else if (this._unit === CapacityDto.UnitEnum.LITER && this._value < 1) {
      this._value = this._value * 1000;
      this._unit = CapacityDto.UnitEnum.MILLILITER;
    }
  }

  public toMl() {
    if (this._unit === CapacityDto.UnitEnum.MILLILITER) {
      return new Capacity(this._value, CapacityDto.UnitEnum.MILLILITER, false);
    } else {
      return new Capacity(this._value * 1000, CapacityDto.UnitEnum.MILLILITER, false);
    }
  }

  public toLitr() {
    if (this._unit === CapacityDto.UnitEnum.LITER) {
      return new Capacity(this._value, CapacityDto.UnitEnum.LITER, false);
    } else {
      return new Capacity(this._value / 1000, CapacityDto.UnitEnum.LITER, false);
    }
  }

}


// WEBPACK FOOTER //
// ./src/diary/water/utils/Capacity.ts